import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-discount-authorization',
  templateUrl: './discount-authorization.component.html',
  styleUrls: ['./discount-authorization.component.scss']
})
export class DiscountAuthorizationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
